/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Practice_TitleInputs */

const en_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for repetition.`)
};

const es_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho para la repetición.`)
};

const de_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebaut für die Wiederholung.`)
};

const zh_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专为重复而设计。`)
};

const ar_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مبني للتكرار.`)
};

const fr_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conçu pour la répétition.`)
};

const vi_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiết kế để luyện đi luyện lại.`)
};

const sw_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imeundwa kwa kurudia.`)
};

const th_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างขึ้นเพื่อการทำซ้ำ`)
};

const bs_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Građeno za ponavljanje.`)
};

const ja_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反復練習のための施設。`)
};

const ko_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`반복 연습을 위한 공간.`)
};

const pt_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito para a repetição.`)
};

const it_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruito per la ripetizione.`)
};

const sv_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggd för repetition.`)
};

const nl_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebouwd voor herhaling.`)
};

const da_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygget til gentagelse.`)
};

const nb_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygget for repetisjon.`)
};

const fi_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakennettu toistoa varten.`)
};

const pl_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stworzony do powtórzeń.`)
};

const ru_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создан для повторения.`)
};

const tr_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrar için tasarlandı.`)
};

const hi_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दोहराव के लिए निर्मित।`)
};

const id_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibangun untuk pengulangan.`)
};

const ms_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibina untuk ulangan.`)
};

const cs_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postaveno pro opakování.`)
};

const el_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χτίστηκε για επανάληψη.`)
};

const he_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בנוי לחזרות.`)
};

const af_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebou vir herhaling.`)
};

const hu_range_practice_title = /** @type {(inputs: Range_Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismétlésre tervezve.`)
};

/**
* | output |
* | --- |
* | "Built for repetition." |
*
* @param {Range_Practice_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_practice_title = /** @type {((inputs?: Range_Practice_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Practice_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_practice_title(inputs)
	if (locale === "de") return de_range_practice_title(inputs)
	if (locale === "zh") return zh_range_practice_title(inputs)
	if (locale === "ar") return ar_range_practice_title(inputs)
	if (locale === "fr") return fr_range_practice_title(inputs)
	if (locale === "vi") return vi_range_practice_title(inputs)
	if (locale === "sw") return sw_range_practice_title(inputs)
	if (locale === "th") return th_range_practice_title(inputs)
	if (locale === "bs") return bs_range_practice_title(inputs)
	if (locale === "ja") return ja_range_practice_title(inputs)
	if (locale === "ko") return ko_range_practice_title(inputs)
	if (locale === "pt") return pt_range_practice_title(inputs)
	if (locale === "it") return it_range_practice_title(inputs)
	if (locale === "sv") return sv_range_practice_title(inputs)
	if (locale === "nl") return nl_range_practice_title(inputs)
	if (locale === "da") return da_range_practice_title(inputs)
	if (locale === "nb") return nb_range_practice_title(inputs)
	if (locale === "fi") return fi_range_practice_title(inputs)
	if (locale === "pl") return pl_range_practice_title(inputs)
	if (locale === "ru") return ru_range_practice_title(inputs)
	if (locale === "tr") return tr_range_practice_title(inputs)
	if (locale === "hi") return hi_range_practice_title(inputs)
	if (locale === "id") return id_range_practice_title(inputs)
	if (locale === "ms") return ms_range_practice_title(inputs)
	if (locale === "cs") return cs_range_practice_title(inputs)
	if (locale === "el") return el_range_practice_title(inputs)
	if (locale === "he") return he_range_practice_title(inputs)
	if (locale === "af") return af_range_practice_title(inputs)
	if (locale === "hu") return hu_range_practice_title(inputs)
	return en_range_practice_title(inputs)
});